import { useLayoutEffect } from "react";

export default function useDocumentTitle(title: string) {
  useLayoutEffect(() => {
    window.document.title = title;
  }, []);
}
